import {
  Box,
  Button,
} from '@mui/material';
import { useContext } from 'react';
import DynamicForm from '../DynamicForm';
import { WebContext } from '../../contextProvider/webContextProvider';

function AdditionalLead({ onNext, leadFormData }: any) {
  const { availableOffers } = useContext(WebContext);

  return (
    <Box marginTop="150px">
      { availableOffers?.length>0 ? (
        <Box
          display="flex-column"
          flexDirection="column"
          width="85%"
          mx="auto" 
          alignItems="center" 
          justifyContent="center" 
        >
          {Object.entries(availableOffers).map(([key, item]: [string, any]) =>
            item ? (
              <DynamicForm formItem={item} leadFormData={leadFormData} />
            ) : (
              'No Result Found'
            )
          )}
        </Box>
      ) : (
        'No Result Found'
      )}
      {availableOffers?.length>0 && (
        <Box textAlign="center" mt={2}>
          <Button
            variant="contained"
            color="success"
            size="large"
            sx={{
              textTransform: 'none',
              fontSize: '18px',
              // borderRadius: '8px',
              minWidth: '150px',
            }}
            onClick={onNext}
          >
            See Additional Matches
          </Button>
        </Box>
      )}
    </Box>
  );
}

export default AdditionalLead;
